export const getDDMMYYYYFormat = (utcDateString: string, timezoned: boolean = false): string => {
  const utcTime = new Date(utcDateString.replace('Z', ''))

  const utcYear = utcTime.getUTCFullYear()
  const utcMonth = utcTime.getUTCMonth()
  const utcDay = utcTime.getUTCDate()
  const utcHour = utcTime.getUTCHours()
  const utcMinute = utcTime.getUTCMinutes()
  const utcSecond = utcTime.getUTCSeconds()

  const gmtMinus5Time = new Date(Date.UTC(utcYear, utcMonth, utcDay, utcHour, utcMinute, utcSecond))
  if (timezoned) gmtMinus5Time.setUTCHours(gmtMinus5Time.getUTCHours() - 5) // force to GMT-5

  const day = gmtMinus5Time.getUTCDate()
  const month = gmtMinus5Time.getUTCMonth() + 1
  const year = gmtMinus5Time.getUTCFullYear()

  const formattedDay = day < 10 ? '0' + day : day
  const formattedMonth = month < 10 ? '0' + month : month

  return `${formattedDay}/${formattedMonth}/${year}`
}

export const dateRangePickerDefault = {
  opens: 'left',
  locale: {
    applyLabel: 'Aplicar',
    cancelLabel: 'Cancelar',
    daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    monthNames: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    format: 'DD/MM/YYYY',
  },
  autoUpdateInput: false,
}

export const formatDateTimeUTC = (dateString: string) => {
  const date = new Date(dateString)

  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()

  const formattedDate = `${day}/${month}/${year}`
  // const formattedTime = `${hours}:${minutes}`;

  return formattedDate
}

export function formatTimeToHHMMSS(date: Date) {
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  // const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}`
}

export const getDDMMYYYYHHMMFormatUTC = (stringDate: string) => {
  if (stringDate === '') return ''
  const dateRaw = new Date(stringDate)

  const DDMMYYYY = formatDateTimeUTC(dateRaw.toDateString())
  const HHMM = formatTimeToHHMMSS(dateRaw)

  return `${DDMMYYYY} ${HHMM}`
}